/*
    创建者：shuxiaokai
    创建时间：2019-12-24 17:36
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div>

    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    }
};
</script>



<style lang="scss">

</style>
